export * from "ce/pages/common/PageWrapper";
import { default as CE_PageWrapper } from "ce/pages/common/PageWrapper";
export default CE_PageWrapper;
